import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=04721e41&scoped=true&"
import script from "./Sets.vue?vue&type=script&lang=js&"
export * from "./Sets.vue?vue&type=script&lang=js&"
import style0 from "./Sets.vue?vue&type=style&index=0&id=04721e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04721e41",
  null
  
)

export default component.exports